let pulldowns = document.querySelectorAll(".pulldown")

pulldowns.forEach(
    pulldown=>{
        pulldown.addEventListener("mouseenter",()=>{
            pulldown.classList.add("is-on")
        })
        pulldown.parentNode.addEventListener("mouseleave",()=>{
            pulldown.classList.remove("is-on")
        })
    }
)